import RegisterModule from '../containers/Home/RegisterModule';
import PublicPage from '../containers/Home/PublicPage';

const Home = (props) => {
  if (localStorage.getItem('userToken')) {
    return <RegisterModule {...props} />;
  } else {
    return <PublicPage {...props} />;
  }
};

export default Home;
